import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import ORTypography from 'components/ORTypography/ORTypography';
import Stepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import classname from 'classnames';

import roleDisabled from 'services/roleDisabled/index';
import LoadingPlaceholder from 'components/LoadingPlaceholder/LoadingPlaceholder';
import BillingPageContainer from 'components/BillingPage/BillingPageContainer';
import { OWNER, ADMIN, OR_ADMIN, OR_SUPERUSER } from 'constants/roles';
import SegmentClickTracker from 'components/SegmentClickTracker/SegmentClickTrackerContainer';
import StepOne from './StepOne/StepOneContainer';
import StepTwo from './StepTwo/StepTwo';
import StepThree from './StepThree/StepThree';
import RocketOverview from './RocketOverview/RocketOverview';

const propTypes = {
  activeStep: PropTypes.number.isRequired,
  resetSteps: PropTypes.func.isRequired,
  goToNextStage: PropTypes.func.isRequired,
  goToPreviousStage: PropTypes.func.isRequired,
  classes: PropTypes.shape({}).isRequired,
  newInstance: PropTypes.shape({
    newInstanceName: PropTypes.string.isRequired,
    newInstanceService: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    newInstanceServiceSubtype: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    newInstanceVersion: PropTypes.string.isRequired,
    newInstanceRegion: PropTypes.string.isRequired,
    newInstanceFlavorIndex: PropTypes.number.isRequired,
    newInstancePlan: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    newInstanceAcls: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    newInstanceCloudProvider: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    newInstanceAddons: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  selectService: PropTypes.func.isRequired,
  selectServiceSubtype: PropTypes.func.isRequired,
  selectProvider: PropTypes.func.isRequired,
  selectVersion: PropTypes.func.isRequired,
  selectRegion: PropTypes.func.isRequired,
  enterName: PropTypes.func.isRequired,
  selectFlavor: PropTypes.func.isRequired,
  selectPlan: PropTypes.func.isRequired,
  enterCidr: PropTypes.func.isRequired,
  getIp: PropTypes.func.isRequired,
  getIpClear: PropTypes.func.isRequired,
  myip: PropTypes.string,
  enterAclName: PropTypes.func.isRequired,
  selectAclKind: PropTypes.func.isRequired,
  newAcl: PropTypes.shape({
    id: PropTypes.string,
    cidr: PropTypes.string,
    kind: PropTypes.number,
    name: PropTypes.string,
  }),
  addAcl: PropTypes.func.isRequired,
  removeAcl: PropTypes.func.isRequired,
  addIpsLater: PropTypes.bool.isRequired,
  checkAddIpsLater: PropTypes.func.isRequired,
  catalog: PropTypes.shape({
    regionsCatalog: PropTypes.shape({
      regions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    servicesCatalog: PropTypes.shape({
      services: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    serviceSubtypesCatalog: PropTypes.shape({
      serviceSubtypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    providersCatalog: PropTypes.shape({
      providers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    versionsCatalog: PropTypes.shape({
      versions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    flavorsCatalog: PropTypes.shape({
      flavors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    plansCatalog: PropTypes.shape({
      plans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
    addonsCatalog: PropTypes.shape({
      addons: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    }).isRequired,
  }).isRequired,
  createInstance: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getPrice: PropTypes.func.isRequired,
  getPriceDebounced: PropTypes.func.isRequired,
  needsBilling: PropTypes.bool.isRequired,
  trackButtonClick: PropTypes.func.isRequired,
  setUiState: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  width: PropTypes.string.isRequired,
  user: PropTypes.shape({
    idq: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  price: PropTypes.number.isRequired,
  supportLevelName: PropTypes.string.isRequired,
};

const defaultProps = {
  newAcl: {
    cidr: '',
    kind: 1,
    name: '',
  },
  myip: null,
};

export function UnstyledCreateInstancePage({
  activeStep,
  resetSteps,
  goToNextStage,
  goToPreviousStage,
  classes,
  newInstance,
  selectService,
  selectServiceSubtype,
  selectVersion,
  selectRegion,
  enterName,
  selectProvider,
  catalog,
  selectFlavor,
  selectPlan,
  getIp,
  getIpClear,
  myip,
  enterCidr,
  enterAclName,
  selectAclKind,
  newAcl,
  addAcl,
  removeAcl,
  addIpsLater,
  checkAddIpsLater,
  createInstance,
  history,
  isLoading,
  getPrice,
  getPriceDebounced,
  needsBilling,
  trackButtonClick,
  setUiState,
  open,
  userRoles,
  width,
  user,
  price,
  supportLevelName,
}) {
  const {
    newInstanceName,
    newInstanceService,
    newInstanceVersion,
    newInstanceRegion,
    newInstancePlan,
    newInstanceCloudProvider,
    newInstanceAcls,
    newInstanceFlavorIndex,
    newInstanceServiceSubtype,
    newInstanceAddons,
  } = newInstance;

  const billingOpen = () => {
    setUiState({
      open: !open,
    });
  };

  const isMobile = isWidthDown('sm', width);
  const mobileStepText = ['Step 1 of 3: ', 'Step 2 of 3: ', 'Step 3: '];
  const steps = [
    'Select Service, Region, and Provider',
    `Configure ${activeStep >= 1 ? newInstanceName : ''}`,
    `Add a Whitelist IP ${activeStep >= 1 ? `to ${newInstanceName}` : ''}`,
  ];

  if (isMobile) {
    steps.forEach((step, index) => {
      steps[index] = mobileStepText[index].concat(step);
    });
  }

  const isValid = activeStep === steps.length - 1 && (addIpsLater || newInstanceAcls.length > 0);

  const connector = (
    <StepConnector classes={{ line: classes.connectorBasic, vertical: classes.connectorBasic }} />
  );

  const selectedNewInstanceRegionId =
    newInstanceRegion !== '0'
      ? catalog.regionsCatalog.regions.filter((region) => region.name === newInstanceRegion)[0].id
      : '';

  function getStepContent(step) {
    if (step === 0) {
      return (
        <StepOne
          {...newInstance}
          selectService={selectService}
          selectServiceSubtype={selectServiceSubtype}
          selectVersion={selectVersion}
          selectRegion={selectRegion}
          regions={catalog.regionsCatalog.regions}
          selectProvider={selectProvider}
          enterName={enterName}
          services={catalog.servicesCatalog.services}
          serviceSubtypes={catalog.serviceSubtypesCatalog.serviceSubtypes}
          cloudProviders={catalog.providersCatalog.providers}
          versions={catalog.versionsCatalog.versions}
        />
      );
    }
    if (step === 1) {
      return (
        <StepTwo
          {...newInstance}
          selectFlavor={selectFlavor}
          selectPlan={selectPlan}
          flavors={catalog.flavorsCatalog.flavors}
          plans={catalog.plansCatalog.plans}
          getPrice={getPrice}
          getPriceDebounced={getPriceDebounced}
          regionId={selectedNewInstanceRegionId}
          addons={catalog.addonsCatalog.addons}
          newInstanceAddons={newInstanceAddons}
          user={user}
        />
      );
    }
    return (
      <StepThree
        newInstanceAcls={newInstanceAcls}
        enterCidr={enterCidr}
        getIp={getIp}
        getIpClear={getIpClear}
        myip={myip}
        enterAclName={enterAclName}
        selectAclKind={selectAclKind}
        newAcl={newAcl}
        addAcl={addAcl}
        removeAcl={removeAcl}
        addIpsLater={addIpsLater}
        checkAddIpsLater={checkAddIpsLater}
        newInstanceService={newInstanceService}
      />
    );
  }

  function isStepInvalid(step) {
    if (step === 0) {
      return (
        !newInstanceName ||
        !newInstanceService ||
        newInstanceVersion === '0' ||
        newInstanceRegion === '0'
      );
    }
    return newInstanceFlavorIndex < 0;
  }

  const newInstanceAddonsObject = newInstanceAddons.reduce((curr, newInstanceAddon) => {
    const retObj = { ...curr, [newInstanceAddon.name]: newInstanceAddon.value };
    return retObj;
  }, {});

  const newInstanceData = {
    plan: newInstancePlan.name,
    name: newInstanceName,
    version: newInstanceVersion,
    region: newInstanceRegion,
    provider: newInstanceCloudProvider.name,
    service: newInstanceService.name,
    serviceSubtype: newInstanceServiceSubtype.name,
    features: {
      addons: newInstanceAddonsObject,
    },
    settings: {
      system_userlist: {},
    },
    acls: newInstanceAcls,
  };

  const redirectToInstances = () => history.push('/mission-ctrl/instances');

  const submitButton = (disabled = false) => (
    <SegmentClickTracker buttonName="Create Instance Submit (Mobile)">
      <Button
        className={classname(classes.createButton, classes.stepButton)}
        variant="contained"
        color="primary"
        disabled={!isValid || disabled}
        onClick={() =>
          needsBilling ? billingOpen() : createInstance(newInstanceData, redirectToInstances)
        }
      >
        Create
        <span className={classes.instance}>&nbsp;Instance </span>
      </Button>
    </SegmentClickTracker>
  );

  const createInstanceButton = (button, userAccess, allowedAccess) =>
    roleDisabled(userAccess, allowedAccess) ? (
      <Tooltip title="You do not have the required access for this resource. Contact your organization owner.">
        <span>{button(true)}</span>
      </Tooltip>
    ) : (
      button()
    );

  function getActionButtons(classType, bottomPage = true) {
    return (
      <div className={classname(classes.actionsContainer, classType)}>
        {activeStep > 0 && (
          <SegmentClickTracker buttonName={'Create Instance Step '.concat(activeStep)}>
            <Button
              variant="contained"
              color="secondary"
              onClick={(event) => goToPreviousStage(event, activeStep)}
              className={classname(classes.backButton, classes.stepButton)}
            >
              <ArrowBackIcon />
              <span className={classes.stepButtonLabel}>
                <span className={classes.goto}>Back to</span> step {activeStep}
              </span>
            </Button>
          </SegmentClickTracker>
        )}
        {activeStep < steps.length - 1 && (
          <SegmentClickTracker buttonName={'Create Instance Step '.concat(activeStep + 2)}>
            <Button
              disabled={isStepInvalid(activeStep)}
              variant="contained"
              color="primary"
              onClick={(event) => goToNextStage(event, activeStep)}
              className={classname(classes.nextButton, classes.stepButton)}
            >
              <span className={classes.stepButtonLabel}>
                <span className={classes.goto}>Go to</span> step {activeStep + 2}
              </span>
              <ArrowForwardIcon />
            </Button>
          </SegmentClickTracker>
        )}
        {activeStep === steps.length - 1 &&
          bottomPage &&
          createInstanceButton(submitButton, userRoles, [OWNER, ADMIN, OR_ADMIN, OR_SUPERUSER])}
      </div>
    );
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingPlaceholder />
      ) : (
        <React.Fragment>
          <div className={classes.stepperContainer}>
            <ORTypography variant="h5" component="h1" className={classes.header}>
              Create an Instance
            </ORTypography>
            <Divider className={classes.divider} />
            <Stepper
              activeStep={activeStep}
              orientation="vertical"
              connector={connector}
              classes={{ root: classes.stepperRoot }}
            >
              {steps.map((label, index) => (
                <Step key={label} className={classes.stepContainer}>
                  <StepLabel icon="" classes={{ label: classes.stepLabel }}>
                    {label}
                  </StepLabel>
                  <StepContent className={classes.stepContentContainer}>
                    {getStepContent(index)}
                    {getActionButtons(classes.showWhenBig, false)}
                    <div className={classname(classes.showWhenSmall)}>
                      <RocketOverview
                        classes={{
                          resetContainer: classes.rocketOverview,
                        }}
                        activeStep={activeStep}
                        resetSteps={resetSteps}
                        instanceName={newInstanceName}
                        instanceService={newInstanceService.name}
                        instanceVersion={newInstanceVersion}
                        instanceRegion={newInstanceRegion}
                        instanceProvider={newInstanceCloudProvider.name}
                        instancePlan={newInstancePlan}
                        instanceAcls={newInstanceAcls}
                        isValid={isValid}
                        addIpsLater={addIpsLater}
                        instanceType={newInstanceServiceSubtype.name}
                        newInstanceData={newInstanceData}
                        newInstanceService={newInstanceService}
                        trackButtonClick={trackButtonClick}
                        redirectToInstances={redirectToInstances}
                        createInstance={createInstance}
                        needsBilling={needsBilling}
                        userRoles={userRoles}
                        price={price}
                        supportLevelName={supportLevelName}
                      />
                    </div>
                    {getActionButtons(classes.showWhenSmall)}
                  </StepContent>
                </Step>
              ))}
              <div className={classname(classes.showWhenBig)}>
                <RocketOverview
                  classes={{
                    resetContainer: classes.rocketOverview,
                  }}
                  activeStep={activeStep}
                  resetSteps={resetSteps}
                  instanceName={newInstanceName}
                  instanceService={newInstanceService.name}
                  instanceVersion={newInstanceVersion}
                  instanceRegion={newInstanceRegion}
                  instanceProvider={newInstanceCloudProvider.name}
                  instancePlan={newInstancePlan}
                  instanceAcls={newInstanceAcls}
                  isValid={isValid}
                  addIpsLater={addIpsLater}
                  instanceType={newInstanceServiceSubtype.name}
                  newInstanceData={newInstanceData}
                  newInstanceService={newInstanceService}
                  trackButtonClick={trackButtonClick}
                  redirectToInstances={redirectToInstances}
                  createInstance={createInstance}
                  needsBilling={needsBilling}
                  userRoles={userRoles}
                  price={price}
                  supportLevelName={supportLevelName}
                />
              </div>
            </Stepper>
          </div>
          <BillingPageContainer
            open={open}
            billingOpen={billingOpen}
            createInstance={createInstance}
            newInstanceData={newInstanceData}
            redirectToInstances={redirectToInstances}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

UnstyledCreateInstancePage.propTypes = propTypes;
UnstyledCreateInstancePage.defaultProps = defaultProps;

const styles = (theme) => ({
  stepperRoot: {
    padding: 0,
  },
  stepperContainer: {
    padding: theme.spacing(1),
  },
  divider: {
    marginBottom: theme.spacing(1.5),
  },
  header: {
    marginBottom: theme.spacing(2),
    color: theme.customColors.black,
  },
  backButton: {
    marginRight: theme.spacing(1) / 2,
  },
  nextButton: {
    marginLeft: theme.spacing(1),
    color: theme.customColors.black,
  },
  stepLabel: {
    fontSize: '1.571rem',
  },
  stepButton: {
    flexGrow: 0.2,
    '& svg': {
      fontSize: '1.2rem',
    },
  },
  stepButtonLabel: {
    flexGrow: 3,
  },
  createButton: {
    color: theme.customColors.black,

    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.breakpoints.unit / 2,
    },
  },
  instance: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  stepContainer: {
    border: '1px solid',
    borderColor: theme.customColors.lightGrey,
    padding: `0 ${theme.spacing(1)}px`,
  },
  stepContentContainer: {
    border: 'unset',
    margin: 'unset',
    padding: 'unset',
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  resetContainer: {
    padding: theme.spacing(3),
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
  },
  connectorBasic: {
    border: 'unset',
    padding: 'unset',
    minHeight: 'unset',
  },
  showWhenBig: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  showWhenSmall: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  rocketOverview: {
    paddingBottom: '0px',
    paddingLeft: '8px',
    paddingRight: '8px',

    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  [theme.breakpoints.down('sm')]: {
    rocketOverview: {
      border: '0px',
    },
    stepLabel: {
      fontSize: '1.3rem',
    },
    goto: {
      display: 'none',
    },
    actionsContainer: {
      margin: '10px',
      justifyContent: 'activeStep',
    },
    stepButton: {
      flexGrow: 0.5,
    },
    nextButton: {
      marginLeft: 0,
    },
  },
});

export const uiConfig = {
  name: 'createInstance',
  state: () => ({
    open: false,
  }),
};

export default withWidth()(uiState(uiConfig)(withStyles(styles)(UnstyledCreateInstancePage)));
